import { Command } from '@nextforce/api'
import React, { useState } from 'react'
import { StyleProp, ViewStyle } from 'react-native'
import { confirmationAlert } from 'shared/alerts'
import { RoundedButton } from 'shared/components/rounded-button'

interface Props {
  command: Command
  onPress(command: Command): Promise<void>
  containerStyle?: StyleProp<ViewStyle>
  buttonStyle?: StyleProp<ViewStyle>
  disabled?: boolean
}

export function CommandButton({
  containerStyle,
  buttonStyle,
  command,
  onPress,
  disabled,
}: Props) {
  const [isLoading, setLoading] = useState(false)
  const { title, style, confirmation, disabled: disableCommand } = command
  const shouldDisable = disableCommand || disabled

  return (
    <RoundedButton
      title={title}
      onPress={async () => {
        if (confirmation) {
          const isConfirmed = await confirmationAlert(
            confirmation.title,
            confirmation.message
          )

          if (!isConfirmed) {
            return
          }
        }

        await runCommand()
      }}
      containerStyle={containerStyle}
      buttonStyle={buttonStyle}
      emphasized={style === 'primary'}
      loading={isLoading}
      disabled={shouldDisable}
    />
  )

  async function runCommand() {
    setLoading(true)
    await onPress(command)
    setLoading(false)
  }
}
